import {graphql, useStaticQuery} from "gatsby";


const useIndexData = () => {
    const data = useStaticQuery(
        graphql`
 query{
        allStrapiProductUpdate(sort: {fields: date, order: DESC}) {
            edges {
              node {
                title
                description
                content {
                    data {
                        content
                    }
                }
                slug
                date(formatString: "MMMM Do, YYYY")
                img {
                  url
                }
              }
            }
        }
        strapiFooter {
        columns {
          title
          links {
            text
            url
          }
        }
        backgroundShapes {
            color
            shapeId
            side
          }
      }
    }
`)
    return data
}

export default useIndexData


